function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 12a.5.5 0 000-1 4 4 0 110-8 .5.5 0 100-1 5 5 0 100 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 12a.5.5 0 010-1c.33 0 .656-.04.971-.119a.5.5 0 01.242.97A5.01 5.01 0 018 12zm2.862-.9a.5.5 0 01-.573-.82c.268-.187.513-.407.728-.653a.5.5 0 11.754.657 5.025 5.025 0 01-.909.816zm1.832-2.375a.5.5 0 01-.938-.345c.112-.305.187-.624.221-.951a.5.5 0 01.995.105c-.044.41-.137.809-.278 1.191zm.126-3.059a.5.5 0 01-.964.266 3.972 3.972 0 00-.374-.902.5.5 0 11.87-.494c.201.356.359.735.468 1.13zm-1.709-2.58a.5.5 0 11-.622.782 4 4 0 00-.834-.51.5.5 0 11.414-.91 5 5 0 011.042.638zM8.331 2.01a.5.5 0 11-.065.998A4.065 4.065 0 008.019 3a.5.5 0 01.005-1c.103 0 .205.004.307.01zM8 7V4.5a.5.5 0 011 0v3a.5.5 0 01-.5.5h-2a.5.5 0 010-1H8z"
}));
function SvgShiftOeWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
}
export default SvgShiftOeWhite;